
export default function Page404() {
  return (
    <>
      hi
    </>
  );
}
